'use strict';
import { Injectable } from '@angular/core';
import { HttpHeaders } from '@angular/common/http';
import { environment } from "environments/environment";

@Injectable()
export class APPService {
  constructor() { }

  public static APP_URL = environment.appURL;

  public static defaultHTTPOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json; charset=utf-8'
      // , 'Authorization': 'X-API-KEY ' + process.env.WEBSVCAPIKEY
    })
  };
}
